<div class="add-part" [ngClass]="{ 'no-inventory': !part?.stocked || !isInventoryEnabled }">
  <!-- header -->
  <div class="part-header mb-0">
    <div class="ui-g-12 flex-between-center p-0">
      <div class="flex-start-center width-100p">
        <i class="fal fa-tools header-icon ml"></i>
        <div class="width-100p p-relative font-600 font-16 mt-1">Part Details</div>
      </div>
      <i id="close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog(false)"></i>
    </div>
  </div>

  <!-- Start Add New Parts Body -->
  <div class="ui-g part-body pt-0 pb-0 border-bottom-light" *ngIf="!isLoadingPartModal">
    <div class="ui-g-3 inputs-column-spacing part-inner-body pr-0">
      <div class="w-98">
        <div class="pointer sidebar-item" (click)="scrollToSection('basic')"
          [ngClass]="selectedSidebarTab === 'basic' && 'active'">Basic Information</div>
        <div class="pointer sidebar-item" (click)="scrollToSection('pricing')"
          [ngClass]="selectedSidebarTab === 'pricing' && 'active'">Pricing</div>
        <div class="pointer sidebar-item" (click)="scrollToSection('part')"
          [ngClass]="selectedSidebarTab === 'part' && 'active'">Part Classification</div>
        <div *ngIf="part.isFluid" class="pointer sidebar-item" (click)="scrollToSection('fluid')"
          [ngClass]="selectedSidebarTab === 'fluid' && 'active'">Fluid Information</div>
        <div *ngIf="isPartWarrantiesEnabled" class="pointer sidebar-item" (click)="scrollToSection('warranty')"
          [ngClass]="selectedSidebarTab === 'warranty' && 'active'">Parts Warranty
        </div>

        <div *ngIf="isMarkAsInventoryEnabled &&
        ((part?.stocked || part?.hasMarkedInventory) || !isOpenFromRO)" class="pointer sidebar-item"
          (click)="scrollToSection('invDetails')" [ngClass]="selectedSidebarTab === 'invDetails' && 'active'">
          Inventory Details
        </div>

        <div class="pointer sidebar-item" (click)="scrollToSection('generalSettings')"
          [ngClass]="selectedSidebarTab === 'generalSettings' && 'active'">General Settings</div>
        <div class="pointer sidebar-item" (click)="scrollToSection('additionalDetails')"
          [ngClass]="selectedSidebarTab === 'additionalDetails' && 'active'">Additional Details</div>

        <div class="pointer sidebar-item mt-2 flex-between-center" (click)="onTabSelect(1)"
          [ngClass]="selectedTab === 1 && 'active'">
          <div>Activity Logs</div>
          <div>
            <i class="fas fa-chevron-right font-secondary"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-g-9 inputs-column-spacing part-inner-body" #partBody (scroll)="onSectionChange($event,'20')" [hidden]="selectedTab === 1">
      <!-- Basic Info section -->
      <div class="input-basic-info-wrapper ui-g-12 mb-2" id="basic">
        <h5 class="input-heading">Basic Information</h5>
        <div class="ui-g-12 p-0 input-control-container">
          <div class="ui-g-6 p-0 flex-start-center mt-3">
            <div class="width-100p pr-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Part Number</label>
              </div>
              <app-input id="part-number" type="text" placeholder="Enter Part Number" theme="border" [fontSize]="14"
                name="number" [autoFocus]="true" [value]="part.number" [maxLength]="50" [disabled]="isPartsOrderingItem"
                (appFocus)="focusInput('number')" (appBlur)="blurInput('number')"
                (appChange)="handleChange('number', $event)">
              </app-input>
            </div>
          </div>

          <div class="ui-g-6 p-0 flex-start-center mt-3" *ngIf="!companyLocalization; else nameLocalizationFlag">
            <div class="width-100p pl-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Part Name*</label>
              </div>

              <app-input id="part-name" type="text" [placeholder]="'Enter Part Name'" theme="border" [fontSize]="14"
                name="name" [value]="part.name" [maxLength]="50" [isInvalid]="errors.name" [errorMessage]="errors.name"
                (appFocus)="focusInput('name')" (appBlur)="blurInput('name', $event)"
                (appChange)="handleChange('name', $event)">
              </app-input>
            </div>
          </div>
          <ng-template #nameLocalizationFlag>
            <div class="ui-g-12 p-0 flex-start-center mt-3 d-flex"
              [ngClass]="{ 'flex-row-reverse': currentLang === 'fr' }">
              <div class="width-100p primary-active-border" [ngClass]="{ 'pl-2': currentLang === 'fr' }">
                <div class="d-flex">
                  <label class="label-heading font-16 font-600">Part Name (EN){{ currentLang === 'en' ? '*' : ''
                    }}</label>
                </div>

                <app-input id="part-name" type="text" [placeholder]="'Enter Part Name'" theme="border" [fontSize]="14"
                  name="name" [value]="part.name" [maxLength]="50" [isInvalid]="errors.name"
                  [errorMessage]="errors.name" (appFocus)="focusInput('name')" (appBlur)="blurInput('name', $event)"
                  (appChange)="handleChange('name', $event)">
                </app-input>
              </div>
              <div class="width-100p primary-active-border" [ngClass]="{ 'pl-2': currentLang === 'en' }">
                <div class="d-flex">
                  <label class="label-heading font-16 font-600">Part Name (FR){{ currentLang === 'fr' ? '*' : ''
                    }}</label>
                </div>

                <app-input id="part-name" type="text" [placeholder]="'Enter Part Name'" theme="border" [fontSize]="14"
                  name="name" [value]="part.titleFR" [maxLength]="50" [isInvalid]="errors.titleFR"
                  [errorMessage]="errors.titleFR" (appFocus)="focusInput('titleFR')"
                  (appBlur)="blurInput('titleFR', $event)" (appChange)="handleChange('titleFR', $event)">
                </app-input>
              </div>
            </div>
          </ng-template>

          <div class="ui-g-6 p-0 flex-start-center part-add-auto-complete mt-3">
            <div class="width-100p pr-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Brand</label>
              </div>
              <app-auto-complete id="part-brand" listId="part-brand-list" placeholder="Brand" field="brandName"
                scrollHeight="180px" theme="border" [disabled]="false" [hasEditableField]="false"
                [isLoading]="isBrandLoading" [hasFutureSelectionField]="false" [closeOnSelection]="true"
                [isDropdownIconVisible]="true" [hasStaticUnassignedFiled]="false" [suggestions]="partBrandsSuggestion"
                [listItemFontSize]="14" [value]="part?.partBrand?.brandName" [fontSize]="14"
                (appSelect)="onBrandProductLineSelect('partBrand', $event)"
                [isClearIconVisible]="part?.partBrand?.brandName" (appCompletedMethod)="onPartBrandSearch($event)"
                (appClear)="onClearPartBrand()">
              </app-auto-complete>
            </div>
          </div>

          <div class="ui-g-6 p-0 flex-start-center part-add-auto-complete mt-3">
            <div class="width-100p pl-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Product Line</label>
              </div>

              <app-auto-complete id="part-product-line" listId="part-product-line-list" placeholder="Product Line"
                field="name" scrollHeight="180px" theme="border" editableItemIdKey="subCategoryId"
                [isLoading]="isProductLineLoading" [disabled]="!part?.partBrand?.brandName"
                editFieldLabel="Create Product Line" [hasEditableField]="true" [hasFutureSelectionField]="false"
                [closeOnSelection]="true" [isDropdownIconVisible]="true" [hasStaticUnassignedFiled]="false"
                [suggestions]="partProductLineSuggestion" [listItemFontSize]="14" [fontSize]="14"
                [isClearIconVisible]="part?.productLine?.name" [value]="part?.productLine?.name"
                (appSelect)="onBrandProductLineSelect('productLine', $event)"
                (appCompletedMethod)="onPartProductLineSearch($event)" (appSave)="onSaveProductLine($event)"
                (appUpdateItem)="onProductLineUpdate($event)" (appClear)="onClearPartProductLine()">
                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div class="tag-item flex-between-center">
                    <div>{{ item?.name }}</div>
                    <div class="tag-item-action flex-end-center" *ngIf="!item?.isDefault">
                      <i class="far fa-trash p-1 mr-2"
                        (click)="$event.stopPropagation(); onDeleteProductLine(item)"></i>
                      <i class="far fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
          </div>

          <div class="ui-g-6 p-0 flex-start-center part-add-auto-complete mt-3">
            <div class="width-100p pr-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Supplier</label>
              </div>
              <app-auto-complete id="part-create-supplier" listId="part-create-supplier-list" placeholder="Supplier"
                label="Supplier" theme="border" field="name" scrollHeight="180px" editableItemIdKey="_id"
                vPosition="bottom" editFieldLabel="Create Supplier" [hasStaticUnassignedFiled]="false" [fontSize]="14"
                [listItemFontSize]="12" [hasFutureSelectionField]="false" [disabled]="isPartsOrderingItem"
                [floatingLabel]="false" [listItemFontSize]="14" [isDropdownIconVisible]="true"
                [isInvalid]="errors.supplier" [autoFocus]="focus?.supplier || isPreFilledPartFields"
                [suggestions]="suppliersResults" [closeOnSelection]="true" [hasEditableField]="true"
                [value]="part.supplier?.name || ''" [isClearIconVisible]="part.supplier?.name"
                (appFocus)="showSuggestions('supplier')" (appBlur)="blurInput()"
                (appSelect)="onAutoCompleteSelect($event, 'supplier')" (appSave)="saveSupplier($event)"
                (appCompletedMethod)="searchSuggestion($event, 'supplier')" (appUpdateItem)="onUpdateSupplier($event)"
                (appClear)="onClearSuggestion('supplier')">
                <ng-template let-item let-editItem="editItem" appTemplate="item">
                  <div class="tag-item flex-between-center">
                    <span class="font-14">{{ item?.name }}</span>

                    <div class="tag-item-action flex-end-center">
                      <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>
            </div>
          </div>
        </div>

        <div class="ui-g-12 p-0 flex-start-center part-add-auto-complete mt-2">
          <app-switch-pill id="mark-as-fluid" label="Mark as Fluid" position="end" styleClassLabel="font-gray-35"
            [fontSize]="12" [isActive]="part.isFluid" (appChange)="handleChange('isFluid', $event)">
          </app-switch-pill>
        </div>
      </div>

      <div class="input-basic-info-wrapper ui-g-12 mb-2 pricing-section" id="pricing">
        <h5 class="input-heading">
          Pricing
          <span class="ml-2">
            <i class="far fa-sack-dollar pointer font-gray-55"></i>
          </span>
        </h5>
        <div class="ui-g-12 p-0 input-control-container">
          <!-- Cost Type -->
          <div class="cost-type ui-g-6 p-0 flex-start-center mt-3 input-min-height"
            *ngIf="part?.stocked && !isOpenFromPO && !isOpenFromST && !isOpenFromRO">
            <div class="width-100p pr-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Cost Type</label>
              </div>

              <app-auto-complete placeholder="Select*" name="cost-type" field="label" theme="border"
                [suggestions]="costOptions" [fontSize]="13" [closeOnSelection]="true" [hasEditableField]="false"
                [hasCustomEditableField]="false" [autoFocus]="false" inactiveItemsKey="statusActive"
                [selectInactiveItems]="false" [isDropdownIconVisible]="true"
                [disabled]="(isAttributeBasedPricingEnable && !isPricingManagementEnable)"
                [value]="part?.costType === 'cost' ? 'Cost' : part?.costType === 'avg' ? 'Avg. Cost' : 'Latest PO'"
                scrollHeight="276px" (appSelect)="handleChange('costType', $event)">
                <ng-template let-item appTemplate="item">
                  <span class="font-13" [ngClass]="{ 'disabled-status': !item?.statusActive }"> {{ item.label }}</span>
                </ng-template>
              </app-auto-complete>
            </div>
          </div>

          <!-- Cost -->
          <div class="cost-part ui-g-6 p-0 flex-start-center mt-3 input-min-height">
            <div class="width-100p primary-active-border"
              [ngClass]="part?.stocked && !isOpenFromPO && !isOpenFromST && !isOpenFromRO ? 'pl-2' : 'pr-2'">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">
                  Cost*
                  <i *ngIf="part?.isUsingFixedCost" class="fal fa-info-circle font-red-800 pointer"
                    tooltipStyleClass="tooltip-width-350" tooltipPosition="top"
                    pTooltip="The cost field shows the fixed cost. Once PO is delivered, the cost will automatically update to {{part?.costType === 'cost' ? 'Cost' : part?.costType === 'avg' ? 'Avg. Cost' : 'Latest PO'}}"></i>
                </label>
              </div>

              <app-input id="part-cost" type="text" placeholder="Enter Cost" theme="border" [fontSize]="14"
                [isInvalid]="errors.cost" [errorMessage]="errors.cost" name="number" [maxLength]="50"
                [selectTextOnFocus]="true" [allowDecimal]="true"
                [disabled]="isCostEditable()"
                [value]="focus?.cost ? part.cost : (part.cost | currency: usd)" (appFocus)="focusInput('cost')"
                (appBlur)="blurInput('cost')" (appKeyUp)="handleChange('cost', $event)">
              </app-input>
            </div>
          </div>

          <!-- Pricing Matrix -->
          <div class="price-matrix ui-g-6 p-0 flex-start-center mt-3 input-min-height">
            <div class="width-100p primary-active-border"
              [ngClass]="part?.stocked && !isOpenFromPO && !isOpenFromST && !isOpenFromRO ? 'pr-2' : 'pl-2'">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">{{isAttributeBasedPricingEnable ? 'Pricing rules' :
                  'Pricing matrix'}}</label>
              </div>

              <div class="position-relative" [ngClass]="{ 'disabled-autocomplete': !isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable),
                 }" tooltipPosition="top" [pTooltip]="
                  !isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)
                    ? 'Please contact admin / store manager to update'
                    : ''
                ">
                <app-auto-complete id="part-markup" listId="part-markup-list" field="name"
                  [label]="isAttributeBasedPricingEnable ? 'Pricing rules' : 'Pricing matrix'"
                  [placeholder]="isAttributeBasedPricingEnable ? 'Pricing rules' : 'Pricing matrix'"
                  [disabled]="isAttributeBasedPricingEnable"
                  scrollHeight="186px" theme="border"
                  [fontSize]="14"
                  [value]="part?.pricing?.name || pricing?.name"
                  [listItemFontSize]="14" [floatingLabel]="false" [listItemFontSize]="13"
                  [suggestions]="pricingMatrixResults" [isDropdownIconVisible]="isAttributeBasedPricingEnable ? false : true"
                  [isClearIconVisible]="part?.pricing?.name || pricing?.name" [confirmClearReq]="true"
                  (appFocus)="focusInput('markup')" (appBlur)="blurInput('markup')"
                  (appSelect)="handleDropdownSelect($event)" (appCompletedMethod)="onSearchItem('markup', $event)"
                  (appClear)="handleClear('markup')"></app-auto-complete>
                <i *ngIf="isAttributeBasedPricingEnable && part?.pricing?.pricingId || pricing?.pricingId" class="fal fa-info-circle pricing-rule-click"
                  (click)="openMatrixModal(part?.pricing)"></i>
              </div>
            </div>
          </div>
                  <!-- [value]="isPriceCalculated() ? part?.pricing?.name || pricing?.name: isAttributeBasedPricingEnable ? 'no pricing rule' :
                  'no pricing matrix'" -->

          <!-- Price -->
          <div class="Price ui-g-6 p-0 flex-start-center mt-3 input-min-height">
            <div class="width-100p primary-active-border"
              [ngClass]="part?.stocked && !isOpenFromPO && !isOpenFromST && !isOpenFromRO ? 'pl-2' : 'pr-2'">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">
                  {{ isPriceCalculated() ? 'Price (calculated)*' : 'Price (added manually)*' }}
                </label>
              </div>

              <div
                [ngClass]="{ 'disabled-autocomplete': !isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable) }"
                tooltipPosition="top" [pTooltip]="
                  !isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)
                    ? 'Please contact admin / store manager to update'
                    : ''
                ">
                <app-input id="part-price" type="text" theme="border" [fontSize]="14" placeholder="Enter Price"
                  [label]="isPriceCalculated() ? 'Price (calculated)*' : 'Price (added manually)*'"
                  [isInvalid]="errors.price" [errorMessage]="errors.price" [floatingLabel]="false"
                  [autoFocus]="focus.price" [errorMessage]="" [selectTextOnFocus]="true"
                  [value]="focus?.price ? part?.price : (part?.price | currency: usd)"
                  [allowDecimal]="focus?.price ? true : false" (appFocus)="focusInput('price')" maxlength="50"
                  [disabled]="!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)"
                  (appBlur)="blurInput('price')" (appKeyUp)="handleChange('price', $event)">
                </app-input>
              </div>
            </div>
          </div>


          <!-- Default Qty -->
          <div class="default-qty ui-g-6 p-0 flex-start-center mt-3 input-min-height">
            <div class="width-100p primary-active-border"
              [ngClass]="part?.stocked && !isOpenFromPO && !isOpenFromST && !isOpenFromRO ? 'pr-2' : 'pl-2'">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Default Quantity</label>
              </div>
              <app-input id="part-default-qty" type="text" placeholder="Default qty" theme="border"
                [fontSize]="14" [isInvalid]="errors.count" [floatingLabel]="false" [errorMessage]=""
                [disabled]="isPartsOrderingItem" [allowDecimal]="focus?.count ? true : false" [selectTextOnFocus]="true"
                [value]="focus?.count ? part.count : (part.count | number : '1.2-2')" (appFocus)="focusInput('count')"
                (appBlur)="blurInput('count')" (appKeyUp)="handleChange('count', $event)">
              </app-input>
            </div>
          </div>

          <!-- Total cost -->
          <div class="total-cost ui-g-6 p-0 flex-start-center mt-3 input-min-height">
            <div class="width-100p primary-active-border"
              [ngClass]="part?.stocked && !isOpenFromPO && !isOpenFromST && !isOpenFromRO ? 'pl-2' : 'pr-2'">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Total Cost (calculated)</label>
              </div>

              <app-input id="part-total-cost" type="text" placeholder="Total cost" theme="border"
                [fontSize]="14" [isInvalid]="errors.totalCost" [floatingLabel]="false" [errorMessage]=""
                [disabled]="true" [allowDecimal]="focus?.totalCost ? true : false" [selectTextOnFocus]="true"
                [value]="focus?.totalCost ? part.totalCost : (part.totalCost | currency: usd)"
                (appFocus)="focusInput('totalCost')" (appBlur)="blurInput('totalCost')"
                (appKeyUp)="handleChange('totalCost', $event)">
              </app-input>
            </div>
          </div>

          <!-- Total price -->
          <div class="total-price ui-g-6 p-0 flex-start-center mt-3 input-min-height">
            <div class="width-100p primary-active-border"
              [ngClass]="part?.stocked && !isOpenFromPO && !isOpenFromST && !isOpenFromRO ? 'pr-2' : 'pl-2'">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Total Price (calculated)</label>
              </div>
              <app-input id="part-total-price" type="text" placeholder="Total price" theme="border" maxlength="50"
                [fontSize]="14" [isInvalid]="errors.totalPrice" [errorMessage]="" [floatingLabel]="false"
                [selectTextOnFocus]="true" [disabled]="true"
                [value]="focus?.totalPrice ? part?.totalPrice : (part?.totalPrice | currency: usd)"
                [allowDecimal]="focus?.totalPrice ? true : false" [autoFocus]="focus.totalPrice"
                (appFocus)="focusInput('totalPrice')" (appBlur)="blurInput('totalPrice')"
                (appKeyUp)="handleChange('totalPrice', $event)">
              </app-input>
            </div>
          </div>
        </div>

        <div class="ui-g-12 p-0 input-control-container">
          <!-- core cost -->
          <div class="ui-g-6 p-0 flex-start-center mt-3">
            <div class="width-100p pr-2 primary-active-border">
              <app-switch-pill id="part-has-core" label="Part has core cost" position="end"
                styleClassLabel="font-gray-35" [fontSize]="12" [isActive]="part.hasCore"
                [disabled]="isPartsOrderingItem || defaultHasCore" (appChange)="handleChange('hasCore', $event)">
              </app-switch-pill>
            </div>
          </div>

          <div class="ui-g-6 p-0 flex-start-center mt-3" [hidden]="!part.hasCore">
            <div class="width-100p pl-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Core cost</label>
              </div>
              <app-input id="part-core-cost" type="text" placeholder="Core cost" theme="border" styleClassError="pt-1"
                [fontSize]="14" [isInvalid]="errors.coreCost" [errorMessage]="errors.coreCost" [floatingLabel]="false"
                [disabled]="!part.hasCore || isPartsOrderingItem" [selectTextOnFocus]="true" [allowDecimal]="true"
                [value]="focus?.coreCost ? part.coreCost : (part.coreCost | currency: usd)"
                (appFocus)="focusInput('coreCost')" (appBlur)="blurInput('coreCost')"
                (appKeyUp)="handleChange('coreCost', $event)">
              </app-input>
            </div>
          </div>
        </div>

        <div *ngIf="isFeeAssociationEnabled && !['inventoryAdd'].includes(openFrom)"
          class="ui-g-12 p-0 input-control-container mt-3">
          <!-- Hazmat fee section start -->

          <h5 class="input-heading">Associated Fees</h5>

          <div class="hazmat-fee-wrapper" *ngFor="let hazmatFee of hazmatFeeArray; let index = index">
            <div class="hazmat-wrapper">
              <div class="hazmat-fee-search-wrapper mt-3">
                <app-auto-complete placeholder="Search Fee" field="title" theme="border" leftIcon="fad fa-hard-hat"
                  styleClassInputWrapper="p-0 pl-1" styleClassInput="p-1" width="500px" [disabled]="isOpenFromRO"
                  [isLoading]="isSearching" [value]="helperService.getLocalizationValue(currentLang, hazmatFee || {}, 'title')" [fontSize]="14" [hasEditableField]="false"
                  [openDropdownOnGetResult]="true" [hasSearchIcon]="true" [closeOnSelection]="true"
                  [suggestions]="itemResults[index]" (appSelect)="onROSelect($event, index)"
                  (appClear)="onSearchClear(index)" (appCompletedMethod)="hazmatFeeSearchSuggestion($event, index)"
                  (appEnter)="onSearchEnter($event)" scrollHeight="288px">
                  <ng-template let-item let-query="query" appTemplate="item">
                    <div class="fee-search-item flex-start-center width-100p">
                      <i class="fal far fa-usd-circle font-gray-75 p-2"></i>
                      <div class="flex-start-center width-100p">
                        <div class="flex-column width-100p">
                          <div class="search-item-header flex-between-center width-100p">
                            <div class="search-title-wrapper">
                              <p class="m-0 text-truncate search-title">{{ helperService.getLocalizationValue(currentLang, item || {}, 'title') }}</p>
                              <p class="m-0 text-truncate font-11 font-gray-55 search-description width-100p">
                                {{ helperService.getLocalizationValue(currentLang, item, 'description', true) || 'No description' }}
                              </p>
                            </div>

                            <div class="m-0 text-truncate search-price-cost width-100p text-right">
                              <p class="search-price m-0 font-600">Price: {{ item.price || 0 | currency: usd }}</p>
                              <p class="search-cost m-0">Cost: {{ item.cost || 0 | currency: usd }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </app-auto-complete>
              </div>

              <p *ngIf="hazmatFee?.feeValueType && hazmatFee?.feeValueType === 'percent'; else typeFixedTemplate">
                * Total fee will be equal to {{ (hazmatFee?.price / 100) * part?.price || 0 | currency: usd }} per unit
                of the item ({{ hazmatFee?.price }}% * {{ part?.price || 0 | currency: usd }})
              </p>

              <ng-template #typeFixedTemplate>
                <p>* Total fee will be equal to {{ hazmatFee?.price || 0 | currency: usd }} per unit of the item</p>
              </ng-template>
            </div>

            <div class="deleteButton" *ngIf="hazmatFee?._id && !isOpenFromRO">
              <button class="del-btn" (click)="removeHazmatFee(index)">
                <i class="fal fa-trash"></i>
              </button>
            </div>
          </div>

          <p class="font-primary font-600 pointer mt-4" *ngIf="!isOpenFromRO" (click)="addAnotherFee()">
            <ng-container *ngIf="hazmatFeeArray.length > 0; else showFeeText"> <i class="fad fa-plus-circle mr-2"></i>
              Add another fees </ng-container>
            <ng-template #showFeeText> <i class="fad fa-plus-circle mr-2"></i> Add another fee </ng-template>
          </p>
        </div>
      </div>

      <div *ngIf="isNewCategoriesEnabled" class="input-basic-info-wrapper input-default-style ui-g-12 p-0" id="part">
        <h5 class="input-heading">Part Classification</h5>

        <div class="ui-g-10 p-0 input-control-container mt-2" tooltipPosition="top"
          tooltipStyleClass="tooltip-width-medium text-center"
          [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
          <app-auto-complete placeholder="Search" [isDropdownIconVisible]="true" styleClassInputWrapper="p-0 pl-1"
            styleClassListWrapper="w-100" styleClassInput="p-1" theme="border" leftIcon="fal fa-search font-gray"
            noRecordIcon="fal fa-user font-16 pr-2" noRecordText="No category match your search"
            [highlightFirstOption]="false" [hasSearchIcon]="true" field="name" [fontSize]="14" [value]="selectedValue"
            scrollHeight="350px" itemWidth="450px" [closeOnSelection]="true" [openDropdownOnGetResult]="true"
            [hasEditableField]="false" [suggestions]="renderSuggestions()" [defaultSuggestions]="renderSuggestions()"
            [hasCustomListTemplate]="true" [hasCustomEditableField]="true" [disabled]="!canEditClassifications"
            [isClearIconVisible]="selectedValue" (appSelect)="onSelectCategory($event, 'parthTechcategory', null)"
            (appCompletedMethod)="searchCategorySuggestion($event)" (appChange)="handleSearchValue($event)"
            (appClear)="onClearCategorySuggestion('category')">
            <ng-template let-close="close" let-query="query" appTemplate="list">
              <div (scroll)="onScroll($event)" class="scroller h-450" [ngClass]="{ 'scroll-partstech': selectedValue }">
                <!-- Top suggestions -->
                <div class="btm-border" *ngIf="partstechResults?.length">
                  <div class="font-16 font-700 pt-2 pb-2 pl-3">Top suggestions:</div>
                </div>

                <ng-container *ngFor="let item of partstechResults; let index = index">
                  <div class="tag-item flex-between-center pt-2 pb-2 pl-3 suggestions"
                    (click)="onSelectCategory(item, 'parthTechcategory', close, index)">
                    <div class="font-14 font-400">
                      <div class="category-search-header-btn">
                        <app-radio-button styleClassLabel="font-seconday"
                          value="{{ item?.category?.categoryId }}{{ index }}" [selectedValue]="selectedLevel"
                          (appChange)="onSelectCategory(item, 'parthTechcategory', close, index)">
                        </app-radio-button>
                        <span class="text-partstech" [innerHTML]="getPartstechCategoryTitle(item, query)"></span>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <!-- Others -->
                <div class="btm-border top-border mt-3 mb-3" *ngIf="othersResults?.length">
                  <div class="font-16 font-700 mt-2 mb-2 ml-3">Others:</div>
                </div>

                <ng-container *ngFor="let data of othersResults; let index = index">
                  <div class="tag-item flex-between-center pt-2 pb-2 pl-3 suggestions"
                    (click)="onSelectCategory(data, 'parthTechcategory', close, index, true)">
                    <div class="font-14 font-400">
                      <div class="category-search-header-btn">
                        <app-radio-button styleClassLabel="font-seconday" [selectedValue]="selectedLevel"
                          value="{{ data?.category?.categoryId }}{{ index }}-"> </app-radio-button>
                        <span class="text-partstech" [innerHTML]="getPartstechCategoryTitle(data, query)"></span>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-template>
          </app-auto-complete>
        </div>

        <div class="ui-g-12 p-0">
          <div class="ui-g-2 pl-0 pt-3">
            <label class="label-heading font-14 font-400">Standard Category</label>
          </div>

          <div class="ui-g-8 pr-0" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
            [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
            <app-auto-complete id="standard-category" listId="standard-category-list" field="categoryName"
              label="Standard Category" placeholder="Standard Category" scrollHeight="186px" theme="border"
              [value]="part.category?.categoryName" [fontSize]="14" [disabled]="!canEditClassifications"
              [listItemFontSize]="14" [floatingLabel]="false" [isLoading]="loader?.category"
              [isClearIconVisible]="part.category?.categoryName" [suggestions]="categoriesSuggestionsResults"
              [isDropdownIconVisible]="true" (appFocus)="focusInput('category')" (appBlur)="blurInput('category')"
              (appSelect)="categoryDropdownSelect('category', $event)"
              (appCompletedMethod)="onSearchItem('category', $event)"
              (appClear)="handleClear('category')"></app-auto-complete>
          </div>
        </div>

        <div class="ui-g-12 p-0">
          <div class="ui-g-2 pl-0 pt-3 mt-2">
            <label class="label-heading font-14 font-400">Standard Subcategory</label>
          </div>

          <div class="ui-g-8 pr-0 mt-2" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
            [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
            <app-auto-complete id="standard-subcategory" listId="standard-subcategory-list" field="subCategoryName"
              label="Standard Subcategory" placeholder="Standard Subcategory" scrollHeight="186px" theme="border"
              [value]="part.category?.subCategoryName" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="false"
              [isLoading]="loader?.subCategory" [suggestions]="subCategoriesSuggestionsResults"
              [isDropdownIconVisible]="true"
              [disabled]="!part?.category?.categoryId || !part.category?.categoryName || !canEditClassifications"
              [isClearIconVisible]="part.category?.subCategoryName" (appFocus)="focusInput('subCategory')"
              (appBlur)="blurInput('subCategory')" (appSelect)="categoryDropdownSelect('subCategory', $event)"
              (appCompletedMethod)="onSearchItem('subCategory', $event)"
              (appClear)="handleClear('subCategory')"></app-auto-complete>
          </div>
        </div>
        <div class="ui-g-12 p-0">
          <div class="ui-g-2 pl-0 pt-3 mt-2">
            <label class="label-heading font-14 font-400">Standard Part Type</label>
          </div>

          <div class="ui-g-8 pr-0 mt-2" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
            [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">
            <app-auto-complete id="standard-part-type" listId="standard-part-type-list" field="subSubCategoryName"
              label="Standard Part Type" placeholder="Standard Part Type" scrollHeight="186px" theme="border"
              [value]="part?.category?.subSubCategoryName" [fontSize]="14" [listItemFontSize]="14"
              [floatingLabel]="false" [isLoading]="loader?.subSubCategory"
              [disabled]="!part.category?.subCategoryId || !canEditClassifications"
              [isClearIconVisible]="part.category?.subSubCategoryName"
              [suggestions]="subSubCategoriesSuggestionsResults" [isDropdownIconVisible]="true"
              (appFocus)="focusInput('subSubCategory')" (appBlur)="blurInput('subSubCategory')"
              (appSelect)="categoryDropdownSelect('subSubCategory', $event)"
              (appCompletedMethod)="onSearchItem('subSubCategory', $event)"
              (appClear)="handleClear('subSubCategory')"></app-auto-complete>
          </div>
        </div>
        <div class="ui-g-12 p-0">
          <div class="ui-g-2 pl-0 pt-3 mt-2" *ngIf="isNewCategoriesEnabled && isSalesCodeEnabled">
            <label class="label-heading font-14 font-400">Sales Code</label>
          </div>
          <div *ngIf="isNewCategoriesEnabled && isSalesCodeEnabled" class="ui-g-6 pt-3 flex-start-center">
            <div *ngIf="part.salesCode?.title" class="badge-text flex-start-center">
              {{ part?.salesCode?.title }}&nbsp;({{ part?.salesCode?.shortName }})
              <img src="assets/img/icon/edit-outline.svg" class="pointer" tooltipPosition="top"
                tooltipStyleClass="tooltip-width-medium text-center"
                [pTooltip]="!canEditClassifications && !isOpenFromRO ? classificationPrivilegeMsg : ''"
                (click)="openAssignSalesCodeDialog()" />
            </div>
            <div *ngIf="!part.salesCode?.title" tooltipPosition="top"
              tooltipStyleClass="tooltip-width-medium text-center"
              [pTooltip]="!canEditClassifications && !isOpenFromRO ? classificationPrivilegeMsg : ''"
              class="badge-text warning pointer" (click)="openAssignSalesCodeDialog()">
              Assign
              <i class="far fa-plus"></i>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="part?.isFluid" class="input-basic-info-wrapper ui-g-12 mb-2 pricing-section" id="fluid">
        <h5 class="input-heading">Fluid Information</h5>
        <div class="ui-g-12 p-0 input-control-container">
          <!-- fluid type -->
          <div class="ui-g-6 p-0 flex-start-center mt-3 input-min-height">
            <div class="width-100p primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Fluid Type*</label>
              </div>

              <div>
                <app-auto-complete #fluidDropdown id="part-fluidtype" listId="part-fluidType-list" field="name"
                  [label]="'Fluid type'" [placeholder]="'Fluid type'" scrollHeight="186px" theme="border"
                  [value]="part?.fluidDetails?.type" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="false"
                  [listItemFontSize]="13"
                  [suggestions]="[{ labe: 'Engine Oil', name: 'Engine Oil', value: 'engineOil' }]"
                  [isDropdownIconVisible]="true" [isClearIconVisible]="part?.fluidDetails?.type"
                  (appFocus)="focusInput('fluidType')" (appBlur)="blurInput('fluidType')"
                  (appSelect)="handleDropdownFluidSelect('type', $event)"
                  (appClear)="handleClear('type')"></app-auto-complete>
              </div>
              <span class="error-msg">{{errors?.type}}</span>
            </div>
          </div>
          <!-- fluid type end -->

          <!-- Formulation -->
          <div *ngIf="part?.fluidDetails?.type" class="ui-g-6 p-0 pl-2 flex-start-center mt-3 input-min-height">
            <div class="width-100p primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Formulation*</label>
              </div>

              <div>
                <app-auto-complete id="part-formulation" listId="part-formulation-list" field="name" label="Formulation"
                  [placeholder]="'Formulation'" scrollHeight="186px" theme="border" [fontSize]="14"
                  [listItemFontSize]="14" [floatingLabel]="false" [listItemFontSize]="13"
                  [suggestions]="formulationOptions" [isDropdownIconVisible]="true"
                  [value]="part?.fluidDetails?.formulation" [isClearIconVisible]="part?.fluidDetails?.formulation"
                  (appFocus)="focusInput('formulation')" (appBlur)="blurInput('formulation')"
                  (appSelect)="handleDropdownFluidSelect('formulation', $event)"
                  (appClear)="handleClear('formulation')"></app-auto-complete>
              </div>
              <span class="error-msg">{{errors?.formulation}}</span>
            </div>
          </div>

          <!-- Viscosity -->
          <div *ngIf="part?.fluidDetails?.type" class="ui-g-6 p-0 flex-start-center mt-3 input-min-height">
            <div class="width-100p primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Viscosity*</label>
              </div>

              <div>
                <app-auto-complete id="part-viscosity" listId="part-viscosity-list" field="name"
                  [label]="'Select viscosity'" [placeholder]="'Select viscosity'" [isShowError]="true"
                  scrollHeight="186px" theme="border" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="false"
                  [listItemFontSize]="13" [suggestions]="viscosityOptions" [isDropdownIconVisible]="true"
                  [value]="part?.fluidDetails?.viscosity" [isClearIconVisible]="part?.fluidDetails?.viscosity"
                  (appFocus)="focusInput('viscosity')" (appBlur)="blurInput('viscosity')"
                  (appSelect)="handleDropdownFluidSelect('viscosity', $event)"
                  (appClear)="handleClear('viscosity')"></app-auto-complete>
              </div>
              <span class="error-msg">{{errors?.viscosity}}</span>
            </div>
          </div>

          <!-- Unit of Measure as Sold to Customer -->
          <div *ngIf="part?.fluidDetails?.type" class="ui-g-6 p-0 pl-2 flex-start-center mt-3 input-min-height">
            <div class="width-100p primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Unit of Measure as Sold to Customer*</label>
              </div>

              <div>
                <app-auto-complete id="part-unit" listId="part-unit-list" field="name" [label]="'Select measure'"
                  [placeholder]="'Select measure'" scrollHeight="186px" theme="border" [fontSize]="14"
                  [listItemFontSize]="14" [floatingLabel]="false" [listItemFontSize]="13" [suggestions]="measureOptions"
                  [isDropdownIconVisible]="true" [isShowError]="true"
                  [value]="part?.fluidDetails?.unit || defaultMeasure.name"
                  [isClearIconVisible]="part?.fluidDetails?.unit" (appFocus)="focusInput('unit')"
                  (appBlur)="blurInput('unit')" (appSelect)="handleDropdownFluidSelect('unit', $event)"
                  (appClear)="handleClear('unit')"></app-auto-complete>
              </div>
              <div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="isPartWarrantiesEnabled && ((isNewCategoriesEnabled && !isCategorySubTypeFluid) || (!isNewCategoriesEnabled && !this.part.isFluid))"
        class="input-basic-info-wrapper ui-g-12 mb-2" id="warranty">
        <h5 class="input-heading">Parts Warranty</h5>
        <!-- Part warranty eligible section -->
        <div class="ui-g-12 p-0 input-control-container">
          <div class="ui-g-4 p-0 flex-start-center mt-3">
            <div class="width-100p pl-1 pr-2">
              <app-switch-pill id="part-warranty" label="Warranty Eligible" position="end"
                [disabled]="!part?.category?.subSubCategoryId" styleClassLabel="font-gray-35" [fontSize]="12"
                [isActive]="part?.isWarrantyEligible" (appChange)="handleChange('isWarrantyEligible', $event)">
              </app-switch-pill>
            </div>
          </div>

          <!-- Warranty view section -->
          <div class="ui-g-8 p-0 flex-end-center mt-3">
            <button class="btn btn-unassigned-light font-14 font-700">
              {{ part?.isWarrantyEligible && part?.warranty?.warrantySettingId ? part?.warranty?.title : 'Unassigned' }}
              <i class="fa fa-spinner rotate ml-1" *ngIf="isFetchingWarranty"></i>
            </button>
            <div class="pointer font-12 font-700 ml-3" (click)="navigateToWarrantySection()">
              <i class="far fa-external-link-alt font-primary"></i>
              <span class="font-primary pl-2">View Warranty Settings</span>
            </div>
          </div>
        </div>
      </div>


      <div *ngIf="isMarkAsInventoryEnabled &&
      ((part?.stocked || part?.hasMarkedInventory) || !isOpenFromRO)"
        class="input-basic-info-wrapper ui-g-12 mb-2" id="invDetails">
        <h5 class="input-heading">Inventory Details
        </h5>
        <!-- Mark as Inventory -->
        <div class="input-additional-wrapper input-default-style my-0 ui-g-12 p-0">
          <!-- First row -->
          <div class="ui-g-12 mt-3 p-0 input-control-container" style="min-height: 40px !important">
            <div class="ui-g-4 p-0 flex-start-center">
              <div class="width-100p pl-1 pr-2">
                <app-switch-pill id="part-mark-as-inventory" label="Mark as inventory" position="end"
                  styleClassLabel="font-gray-35" [fontSize]="12" [isActive]="part.hasMarkedInventory || part?.stocked"
                  [disabled]="part?.stocked" (appChange)="handleChange('hasMarkedInventory', $event)">
                </app-switch-pill>
              </div>
            </div>

            <div class="ui-g-8 p-0 flex-end-start">
              <div style="min-height: 40px" *ngIf="part?.stocked">
                <div class="icon flex-center-start part-sales-trends" (click)="graphdata(partId, partType)">
                  <app-history-inv-sales-chart [type]="partType" [itemId]="partId"
                    label="Historical sales/reorder trend"> </app-history-inv-sales-chart>
                  <div (click)="openQtyOnEstimateModal()" class="d-flex m-left-35 pointer">
                    <i class="far fa-calendar-check font-primary align-self-center"></i>
                    <p class="mb-0 font-bold font-14 font-primary pl-2">Qty on estimates detail</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Mark as Inventory -->

        <!-- Inventory details First row -->
        <div *ngIf="(part?.stocked || part?.hasMarkedInventory) && isInventoryEnabled" class="ui-g-12 p-0 mt-2 mb-1">
          <div class="d-flex p-0 ui-g-6 inventory-details-wrapper">
            <div class="ui-g-3 d-flex font-12">
              <i class="far fa-boxes height-icon"></i>
              <span class="px-2 align-self-center">Available</span>
              <span class="font-bold align-self-center">{{ part?.qtyAvailable || 0 | number: '1.2-2' }}</span>
            </div>

            <div class="ui-g-1 pl-4 align-self-center">
              <i class="fas fa-equals"></i>
            </div>

            <div class="ui-g-3 d-flex font-12">
              <span class="px-2 align-self-center">On hand</span>
              <span class="font-bold align-self-center">{{ part.qtyOnHand || 0 | number: '1.2-2' }}</span>
            </div>

            <div class="ui-g-1 align-self-center">
              <i class="fas fa-minus"></i>
            </div>

            <div class="ui-g-4 d-flex font-12">
              <span class="px-2 align-self-center">On Estimates</span>
              <span class="font-bold align-self-center">{{ part.qtyOnOrder || 0 | number: '1.2-2' }}</span>
            </div>
          </div>

          <div class="d-flex ui-g-2 mx-3 font-12 inventory-details-wrapper">
            <i class="far fa-truck height-icon"></i>
            <span class="px-2 align-self-center">Ordered</span>
            <span class="font-bold align-self-center">{{ part.qtyOrdered || 0 | number: '1.2-2' }}</span>
          </div>

          <div class="ui-g-12 p-0 input-control-container mt-2">
            <div class="ui-g-3 p-0 flex-start-center">
              <div class="width-100p pl-1 pr-2 position-relative cost-field">
                <div class="d-flex">
                  <label class="label-heading font-16 font-600">Minimum Quantity Level </label>
                </div>
                <app-input class="error" id="part-qty-on-hand" type="text"
                  [allowDecimal]="focus?.restockLevel ? true : false" placeholder="Enter minimum quantity"
                  theme="border" [fontSize]="14" [floatingLabel]="false" [isInvalid]="errors.restockLevel"
                  [errorMessage]="errors.restockLevel"
                  [value]="focus?.restockLevel ? part.restockLevel : (part.restockLevel | number: '1.2-2')"
                  (appFocus)="focusInput('restockLevel')" (appBlur)="blurInput('restockLevel')"
                  (appKeyUp)="handleChange('restockLevel', $event)">
                </app-input>
              </div>
            </div>
            <div class="ui-g-3 p-0 flex-start-center">
              <div class="width-100p pl-1 pr-2 position-relative cost-field">
                <div class="d-flex">
                  <label class="label-heading font-16 font-600">Maximum Quantity Level</label>
                </div>
                <app-input id="part-qty-on-order" type="text" [allowDecimal]="focus?.maxQuantity ? true : false"
                  placeholder="Enter maximum quantity" theme="border" [fontSize]="14" [floatingLabel]="false"
                  [value]="focus?.maxQuantity ? part.maxQuantity : (part.maxQuantity | number: '1.2-2')"
                  (appFocus)="focusInput('maxQuantity')" (appBlur)="blurInput('maxQuantity')"
                  (appKeyUp)="handleChange('maxQuantity', $event)">
                </app-input>
              </div>
            </div>
            <div class="ui-g-6 p-0 flex-start-center">
              <div class="width-100p pl-1 pr-2 position-relative cost-field">
                <div class="d-flex">
                  <label class="label-heading font-16 font-600">Location</label>
                </div>
                <app-auto-complete id="part-locations" position="top" listId="part-locations-list"
                  placeholder="Select..." scrollHeight="186px" theme="border" name="itemRef"
                  styleClassInputWrapper="pl-1" styleClassInput="pl-1" field="name" [value]="part?.location?.name"
                  [isInvalid]="errors.location" [errorMessage]="errors.location" [fontSize]="14" [listItemFontSize]="14"
                  [isClearIconVisible]="part?.location?.name" [suggestions]="locationsResults"
                  [isDropdownIconVisible]="true" (appFocus)="focusInput('location')" (appBlur)="blurInput('location')"
                  (appSelect)="handleConfirmLocationUpdate($event)" (appCompletedMethod)="search($event)"
                  (appClear)="handleClear('location')">
                  <ng-template let-item let-editItem="editItem" appTemplate="item">
                    <div class="tag-item flex-between-center">
                      <span class="font-14">{{ item?.name }}</span>
                    </div>
                  </ng-template>
                </app-auto-complete>
              </div>
            </div>
          </div>
        </div>

        <!-- Transfer order section -->
        <div class="ui-g-12 p-0 mt-2" *ngIf="isMultiLocationEnabled && isStockTransferEnabled">
          <div class="d-flex ui-g-3 flex-between-center font-12 inventory-details-wrapper pointer"
            [pTooltip]="part?.otherLocationDataTooltip" tooltipPosition="bottom"
            tooltipStyleClass="ml-transferorder-tooltip" [escape]="false">
            <div class="flex-row">
              <i class="far fa-boxes height-icon"></i>
              <span class="px-2 align-self-center">Available (other)</span>
            </div>
            <span class="font-bold align-self-center">{{ part?.otherLocationQty || 0 | number: '1.2-2' }}</span>
          </div>

          <div class="d-flex ui-g-2 font-12 pointer flex-around-center pt-1">
            <app-dropdown id="d-action-transfer" listId="d-action-list-transfer" field="label" itemWidth="200px"
              scrollHeight="200px" [options]="transferOptions" [isDropdownIconVisible]="false"
              [hasCustomOpenTemplate]="true" [selectInactiveItems]="false" [hasCustomItemTemplate]="true"
              [isCustomizedTemplate]="true" [disabled]="false" (appSelect)="handleTransferSelect($event)">
              <ng-template let-item appTemplate="open-dropdown-btn">
                <span class="font-12 font-600 font-primary"> <i class="fas fa-exchange pr-2"></i> Transfer </span>
              </ng-template>

              <ng-template let-item appTemplate="item">
                <div class="width-100p flex-between-center">
                  <span class="font-14 font-600">{{ item?.label }}</span>
                </div>
              </ng-template>
            </app-dropdown>
          </div>
        </div>
      </div>

      <!-- General settings info section -->
      <div class="input-basic-info-wrapper ui-g-12 mb-2" id="generalSettings">
        <h5 class="input-heading">General Settings</h5>

        <div class="ui-g-12 p-0 input-control-container mt-2">
          <!-- Taxable -->
          <div class="ui-g-12 p-0 flex-start-center">
            <div class="width-100p pl-1 pr-2">
              <app-switch-pill id="part-tax" label="Taxable" position="end" styleClassLabel="font-gray-35"
                [fontSize]="12" [isActive]="part.isTaxable" (appChange)="handleChange('isTaxable', $event)">
              </app-switch-pill>
            </div>
          </div>

          <!-- Status -->
          <div class="ui-g-12 p-0 flex-start-center mt-2">
            <div class="width-100p pl-1 pr-2">
              <app-switch-pill id="part-qbo-status" [label]="part.status ? ' Active' : ' Inactive'" position="end"
                styleClassLabel="font-gray-35" [fontSize]="12" [disabled]="!!orderServiceId && !updateGenericItem"
                [isActive]="part.status" (appChange)="handleChange('status', $event)"></app-switch-pill>
            </div>
          </div>

          <!-- Commissionable -->
          <div *ngIf="isCommissionPlanEnabled" class="ui-g-12 p-0 flex-start-center mt-3">
            <div class="width-100p pl-1 pr-2">
              <app-switch-pill id="part-commissionable" label="Commissionable" position="end"
                styleClassLabel="font-gray-35" [isActive]="part.commissionable" [fontSize]="12"
                (appChange)="handleChange('commissionable', $event)">
              </app-switch-pill>
            </div>
          </div>

          <!-- Display description -->
          <div class="ui-g-12 p-0 flex-start-center mt-3">
            <div class="width-100p pl-1 pr-2">
              <app-switch-pill id="part-display-qty-ro" label="Display description on estimate and invoice"
                position="end" styleClassLabel="font-gray-35" [isActive]="part.displayDescOnOrder" [fontSize]="12"
                (appChange)="handleChange('displayDescOnOrder', $event)">
              </app-switch-pill>
            </div>
          </div>
        </div>

        <div class="ui-g-12 p-0 input-control-container">
          <!-- Display hours -->
          <div class="ui-g-12 p-0 flex-start-center mt-3">
            <!-- <div class="icon flex-center-start">
                  <i class="far fa-file-invoice height-icon"></i>
                </div> -->

            <div class="width-100p pl-1 pr-2">
              <app-switch-pill id="part-qty-desc-ro" label="Display quantity and price on estimate and invoice"
                position="end" styleClassLabel="font-gray-35" [fontSize]="12" [isActive]="part.displayHoursOnOrder"
                (appChange)="handleChange('displayHoursOnOrder', $event)">
              </app-switch-pill>
            </div>
          </div>

          <!-- QuickBooks reference -->
          <div *ngIf="isQboConnected" class="ui-g-6 p-0 flex-start-center mt-4">
            <div class="width-100p pr-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">QBO item reference</label>
              </div>
              <div class="qbo-autocomplete">
                <app-auto-complete id="ac-part-qbo-reference" listId="ac-part-qbo-reference-list"
                  placeholder="QBO item reference" label="QBO item reference" scrollHeight="186px" theme="border"
                  name="itemRef" styleClassInputWrapper="pl-1" styleClassInput="pl-1" field="title"
                  [value]="part?.itemRef?.title" [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="false"
                  [listItemFontSize]="13" [suggestions]="qboItemRefs" [isDropdownIconVisible]="true"
                  (appFocus)="focusInput('itemRef')" (appBlur)="blurInput('itemRef')"
                  [isClearIconVisible]="part?.itemRef?.title" (appSelect)="handleSelect('itemRef', $event)"
                  (appCompletedMethod)="onSearchItem('itemRef', $event)"
                  (appClear)="handleClear('itemRef')"></app-auto-complete>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- General settings info section ends -->

      <!-- Additional details info section -->
      <div class="input-basic-info-wrapper ui-g-12 mb-4" id="additionalDetails">
        <h5 class="input-heading">Additional Details</h5>

        <div class="ui-g-12 p-0 input-control-container" *ngIf="!companyLocalization; else localizationFlag">
          <!-- Notes -->
          <div class="ui-g-12 p-0 flex-start-center mt-3">
            <div class="width-100p pr-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Part Description</label>
              </div>
              <app-textarea textAreaId="part-save-dialog" theme="border" placeholder="Add Description"
                [maxLength]="10000" [floatingLabel]="false" [autoGrow]="true" [maxAutoGrowHeight]="64" [fontSize]="14"
                [rows]="2" [value]="part.description" [value]="part.description"
                (appChange)="handleChange('description', $event)" (appFocus)="focusInput('description')"
                (appBlur)="blurInput('description')">
              </app-textarea>
            </div>
          </div>
        </div>
        <ng-template #localizationFlag>
          <div class="d-flex"
            [ngClass]="{ 'flex-column-reverse': currentLang === 'fr', 'flex-column': currentLang !== 'fr' }">
            <div class="ui-g-12 p-0 input-control-container">
              <!-- Description -->
              <div class="ui-g-12 p-0 flex-start-center mt-3">
                <div class="width-100p pr-2 primary-active-border">
                  <div class="d-flex">
                    <label class="label-heading font-16 font-600">Part Description (EN)</label>
                  </div>
                  <app-textarea textAreaId="part-save-dialog" theme="border" placeholder="Add Description"
                    [maxLength]="10000" [floatingLabel]="false" [autoGrow]="true" [maxAutoGrowHeight]="64"
                    [fontSize]="14" [rows]="2" [value]="part.description" [value]="part.description"
                    (appChange)="handleChange('description', $event)" (appFocus)="focusInput('description')"
                    (appBlur)="blurInput('description')">
                  </app-textarea>
                </div>
              </div>
            </div>
            <div class="ui-g-12 p-0 input-control-container">
              <!-- Description -->
              <div class="ui-g-12 p-0 flex-start-center mt-3">
                <div class="width-100p pr-2 primary-active-border">
                  <div class="d-flex">
                    <label class="label-heading font-16 font-600">Part Description (FR)</label>
                  </div>
                  <app-textarea textAreaId="part-save-dialog" theme="border" placeholder="Add Description"
                    [maxLength]="10000" [floatingLabel]="false" [autoGrow]="true" [maxAutoGrowHeight]="64"
                    [fontSize]="14" [rows]="2" [value]="part.descriptionFR" [value]="part.descriptionFR"
                    (appChange)="handleChange('descriptionFR', $event)" (appFocus)="focusInput('descriptionFR')"
                    (appBlur)="blurInput('descriptionFR')">
                  </app-textarea>
                </div>
              </div>
            </div>
          </div>
        </ng-template>

        <div class="ui-g-12 p-0 input-control-container mt-3">
          <!-- Notes -->
          <div class="ui-g-12 p-0 flex-start-center">
            <div class="width-100p pr-2 primary-active-border">
              <div class="d-flex">
                <label class="label-heading font-16 font-600">Internal Notes</label>
              </div>
              <app-textarea id="internal-part-desc" textAreaId="internal-disc-desc-textarea" theme="border"
                placeholder="Add Notes" [floatingLabel]="false" [autoGrow]="true" [maxAutoGrowHeight]="64"
                [fontSize]="14" [rows]="2" [value]="part.internalNotes"
                (appChange)="handleChange('internalNotes', $event)" (appFocus)="focusInput('internalNotes')"
                (appBlur)="blurInput('internalNotes')">
              </app-textarea>
            </div>
          </div>
        </div>
      </div>
      <!-- Additional details info section ends-->
    </div>

    <div class="ui-g-9 inputs-column-spacing part-inner-body" #partBody [hidden]="selectedTab === 0">
      <div class="input-basic-info-wrapper ui-g-12 mb-2 height-550px" id="basic">
        <h5 class="input-heading">Activity Logs</h5>
        <div class="ui-g-12 p-0 input-control-container">
          <div class="activity-logs">
            <div class="catalog-activity-wrapper">
              <div *ngIf="activityLogs?.length" class="catalog-activity-inner-wrapper">
                <div *ngFor="let activityLog of activityLogs">
                  <app-catalog-activity-logs [currentLang]="currentLang" [companyLocalization]="companyLocalization"
                    [activityLog]="activityLog"></app-catalog-activity-logs>
                </div>
              </div>
              <div *ngIf="!activityLogs?.length" class="catalog-activity-inner-wrapper no-activity-logs p-3">
                <p>There are no activity logs.</p>
              </div>
              <div class="filter-ddl-wrapper">
                <div class="dropdown">
                  <div class="btn dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    Filter &nbsp;
                    <i *ngIf="isFilterLoading" class="fal fa-spinner rotate"></i>
                    <span *ngIf="filterOption?.length" class="filter-count-bubble">{{ selectedFilterOptionLength
                      }}</span>
                  </div>

                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                    <ul class="catalog-list-filter">
                      <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                        <app-checkbox label="Item history" [isChecked]="filterOptionModel.itemHistory" [fontSize]="12"
                          (appChange)="onCheckboxChange($event, 'catalog-item')"> </app-checkbox>
                      </li>
                      <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                        <app-checkbox label="Pricing history" [isChecked]="filterOptionModel.pricingHistory"
                          [fontSize]="12" (appChange)="onCheckboxChange($event, 'item-pricing')"> </app-checkbox>
                      </li>
                      <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                        <app-checkbox label="Purchase history" [isChecked]="filterOptionModel.purchaseHistory"
                          [fontSize]="12" (appChange)="onCheckboxChange($event, 'ci-purchase-history-po')">
                        </app-checkbox>
                      </li>
                      <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                        <app-checkbox label="Selling history" [isChecked]="filterOptionModel.sellingHistory"
                          [fontSize]="12" (appChange)="onCheckboxChange($event, 'ci-sale-history-ro')">
                        </app-checkbox>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Add New Parts Body -->

  <div class="part-body flex-center-center" *ngIf="isLoadingPartModal">
    <span class="flex-row font-18 flex-center-center">
      <i class="fa fa-spinner rotate"></i>
    </span>
  </div>

  <!-- Start Add Parts Footer -->
  <div class="ui-g-12 flex-between-center dialog-footer part-footer">
    <div class="part-add-dialog-footer d-flex justify-content-between width-100p">
      <div>
        <span *ngIf="!partId && !orderServiceId && !['cannedService', 'catalog', 'inventoryAdd'].includes(openFrom)"
          class="width-100p">
          <app-checkbox inputId="cb-part-add-another" label="Add another" [isChecked]="isCreateMultiple"
            (appChange)="handleMultiplePartCheck($event)"> </app-checkbox>
        </span>
        <span *ngIf="(orderServiceId || isOpenFromPO) && partId && !isOpenFromMO" class="width-100p"
          [ngClass]="{ invisible: !isOpenFromPO && (isLocal || !orderServiceId) }">
          <app-checkbox inputId="cb-part-add-another" label="Also update part across application"
            [isChecked]="updateGenericItem"
            [disabled]="isPricingManagementEnable && !isPricingMatricesManagement && (part?.isChangeInPriceMatrix || isChangeInPriceMatrix)"
            tooltipPosition="top" tooltipStyleClass="tooltip-width-200" [pTooltip]="
              isPricingManagementEnable && !isPricingMatricesManagement && (part?.isChangeInPriceMatrix || isChangeInPriceMatrix)
                ? 'Current pricing is different from default. Please contact admin / store manager to update'
                : ''
            " (appChange)="updateGenericItem = $event; part.status = defaultActiveState">
          </app-checkbox>
        </span>
        <span *ngIf="isOpenFromMO" class="width-100p">
          You can only update part location from this modal
        </span>
      </div>

      <div>
        <button id="part-cancel-btn" class="btn btn-border pointer btn-submit mr-1"
          (click)="closeDialog()">Cancel</button>

        <button id="part-save-btn" class="btn btn-primary btn-submit" tooltipPosition="top"
          [pTooltip]="isLockedRO ? 'Sorry, cannot make any changes to a Locked RO' : isFinalizedRo ? 'Sorry, cannot make any changes to a finalized RO' : ''"
          [disabled]="isProcessing || isLoading || isFinalizedRo || isLockedRO || isFetchingWarranty"
          (click)="onSubmit()">
          <span [ngClass]="{ 'pr-2': isProcessing || isLoading }">Save</span>
          <i *ngIf="isProcessing || isLoading || isFetchingWarranty" class="far fa-spinner rotate"></i>
        </button>
      </div>
    </div>
  </div>
</div>
